import { css, styled } from 'styled-components';

import type { Color } from '#/theme/theme';
import { colors, cssBreakpoints, fontWeights, spacing } from '#/theme/theme';

export const listingViewHeaderDesktopShadowSize = 24;

export const ListingViewHeaderHolder = styled.header`
  position: relative;

  /* Below md the visual order is listing summary, type label, published row.
     DOM order is unchanged */
  &[data-mobile-compact] {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const ListingViewHeaderTypeLabelHolder = styled.div`
  ${ListingViewHeaderHolder}[data-mobile-compact] & {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      order: 2;
      /* The listing summary's grey shadow runs to the holder's edge */
      margin-top: ${spacing[24]};
    }
  }
`;

export const ListingViewHeaderPublishedRowHolder = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[16]};

  ${ListingViewHeaderHolder}[data-mobile-compact] & {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      order: 3;
    }
  }
`;

export const ListingViewHeaderTagHolder = styled.div<{
  $color: Color;
}>`
  margin-top: 24px;
  display: inline-flex;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 8px;
    padding: 8px ${listingViewHeaderDesktopShadowSize}px;
    transform: translateX(-${listingViewHeaderDesktopShadowSize}px);

    ${(props) => css`
      background: ${colors[props.$color]};
    `};
  }
`;

export const ListingViewHeaderContentHolder = styled.div`
  /* Compensate for box-shadow in ListingViewHeaderContent */
  padding: ${listingViewHeaderDesktopShadowSize}px 0;
  margin-top: 24px;

  ${ListingViewHeaderHolder}[data-mobile-compact] & {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      order: 1;
      /* The listing summary is first now, so there is nothing to space it from */
      margin-top: 0;
    }
  }
`;

export const ListingViewHeaderContent = styled.div`
  background: ${colors.backgroundGrey};
  box-shadow: 0 0 0 ${listingViewHeaderDesktopShadowSize}px
    ${colors.backgroundGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 4px;
  }
`;

export const ListingViewHeaderTitle = styled.h1`
  font-size: 36px;
  color: ${colors.mediumContentGrey};
  margin: 0;
  font-weight: ${fontWeights.semiBold};
  word-break: normal;
  overflow-wrap: anywhere;

  ${ListingViewHeaderHolder}[data-mobile-compact] & {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      font-size: 32px;
    }
  }
`;

export const ListingViewHeaderOrgName = styled.div`
  font-size: 20px;
  margin-top: 8px;
`;

export const ListingViewHeaderLocationDescription = styled.div`
  border-top: 1px solid ${colors.dustyBlue};
  padding-top: 16px;
  margin-top: 16px;
  display: flex;
  gap: 4px;
`;
